import { render } from "./SystemAnalyticsPage.vue?vue&type=template&id=d8c20bfe&scoped=true"
import script from "./SystemAnalyticsPage.vue?vue&type=script&lang=js"
export * from "./SystemAnalyticsPage.vue?vue&type=script&lang=js"

import "./SystemAnalyticsPage.vue?vue&type=style&index=0&id=d8c20bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c20bfe"]])

export default __exports__